<script setup>
import { useDateFormat, watchTriggerable } from '@vueuse/core';

const userStore = useUserStore();
const modalStore = useModalStore();

const { $localApi } = useNuxtApp();

const loading = ref(false);

const isLive = ref(false);

onMounted(() => {
  trigger();
});

const { trigger } = watchTriggerable(
  () => userStore.GET_INSTANT_LIVE_ID,
  () => {
    isLive.value = !!userStore.GET_INSTANT_LIVE_ID;
  },
);

async function goLiveHandle() {
  loading.value = true;

  try {
    if (!userStore.IS_AUTHORIZED) {
      modalStore.SHOW_MODAL({ component: 'MoleculeModalNeedAuth' });
      return;
    }

    if (!userStore.IS_SUBSCRIBED) {
      modalStore.SHOW_MODAL({ component: 'MoleculeModalNeedSubscribe' });
      return;
    }

    const date = new Date();

    if (userStore.GET_INSTANT_LIVE_ID) {
      const { error } = await $localApi.post(`/event/${userStore.GET_INSTANT_LIVE_ID}/stop/`);

      if (error.value) {
        return;
      }

      userStore.SET_INSTANT_LIVE_ID(null);

      return;
    }

    const { data, error } = await $localApi.post('/event/create', {
      body: {
        isInstant: true,
        timezone: new Date().toString().match(/([A-Z]+[+-][0-9]+)/)[1],
        date: useDateFormat(date, 'MM/DD/YYYY'),
        time: useDateFormat(date, 'HH:mm'),
      },
    });

    if (error.value) {
      loading.value = false;
      return;
    }

    if (data.value._id) {
      userStore.SET_INSTANT_LIVE_ID(data.value._id);
      navigateTo({ name: 'program-play', params: { id: data.value._id } });
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <button class="relative" :class="{ 'cursor-progress opacity-25': loading }" @click="goLiveHandle">
    <MoleculeNuxtIcon
      class="size-7 fill-[url(#gradient-lightblue-purple)] group-hover:fill-white"
      name="golive"
    />

    <slot />

    <span class="sr-only">Go Live</span>
  </button>
</template>
